import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class HttpError<T = any, D = any> implements AxiosError {
  readonly name: string;
  readonly message: string;
  readonly error: AxiosError<T, D>;
  readonly config: AxiosRequestConfig<D>;
  readonly code?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly request?: any;
  readonly response?: AxiosResponse<T, D>;
  readonly isAxiosError: boolean;
  _isCancel: boolean;

  constructor(error: AxiosError, message = "This is HttpError.") {
    this.name = "HttpError";
    this.message = message;
    this.error = error;
    this.config = error.config;
    this.code = error.code;
    this.request = error.request;
    this.response = error.response;
    this.isAxiosError = error.isAxiosError;
    this._isCancel = axios.isCancel(error);
  }

  isCancel(): boolean {
    const mapError = (e: HttpError): boolean => {
      if (e.error instanceof HttpError) {
        return mapError(e.error);
      } else {
        return e._isCancel;
      }
    };
    return mapError(this);
  }

  toJSON() {
    return this.error;
  }
}
